export const Dictionary = {
    /** 利用方法 */
    CngMethodType: {
        1: { 1: '対面', 2: 'Face-to-face' },
        2: { 1: '電話', 2: 'Call' },
        3: { 1: 'オンライン', 2: 'Online' },
    },
    /** 予約方法 */
    CngReserveType: {
        1: { 1: 'カレンダー', 2: 'Calendar' },
        2: { 1: 'アレンジ', 2: 'Arrange' },
    },
    /** 予約ステータス */
    ReservationStatus: {
        1: { 1: '受付', 2: 'Reception' },
        2: { 1: '確定', 2: 'Confirmation' },
        3: { 1: 'キャンセル', 2: 'Cancel' },
        4: { 1: '当日キャンセル', 2: 'Same-day cancellation' },
    },
    /** 事前問診ステータス */
    InterviewStatus: {
        0: { 1: '対象外', 2: 'Not applicable' },
        1: { 1: '未回答', 2: 'No response' },
        2: { 1: '回答済み', 2: 'Answered' },
    },
    /** アンケートステータス */
    QuestionStatus: {
        0: { 1: '対象外', 2: 'Not applicable' },
        1: { 1: '未回答', 2: 'No response' },
        2: { 1: '回答済み', 2: 'Answered' },
    },
    /** サービスの電話相談方法 */
    ServiceTelMet: {
        1: { 1: '利用者から架電', 2: 'Call from user' },
        2: { 1: 'カウンセラーから架電', 2: 'Call from counselor' },
    },
    /** 利用者種別 */
    ClientType: {
        1: { 1: '従業員', 2: 'Employee' },
        2: { 1: '家族', 2: 'Family' },
    },
    /** 利用者種別 */
    Gender: {
        1: { 1: '男性', 2: 'Mail' },
        2: { 1: '女性', 2: 'Femail' },
        3: { 1: '回答しない', 2: 'No Answer' },
    },
    /** 利用者種別 */
    Lang: {
        1: { 1: '日本語', 2: 'Japanese' },
        2: { 1: '英語', 2: 'English' },
    },
    /** Web相談詳細画面の連絡項目の表示名称 */
    WebCngMsgType: {
        1: { 1: 'あなた', 2: 'User' },
        2: { 1: 'カウンセラー', 2: 'Counselor' },
    },
    /** 決済ステータス */
    PaymentStatus: {
        1: { 1: '未決済', 2: 'Unpaid' },
        2: { 1: '決済完了', 2: 'Paid' },
        3: { 1: 'キャンセル', 2: 'Cancel' },
        4: { 1: '決済不要', 2: 'Not required' },
    },
};
